export default "__VITE_ASSET__bf186df6__"